import { createReducer, on } from "@ngrx/store";
import { map } from "rxjs";
import { login, loginError, loginSuccess,  logout, logoutSuccess, logoutError, addAplicacion, addAplicacionError, addAplicacionSuccess} from "./usuario.actions";
import { Usuario, UsuarioRedux } from 'src/app/models/usuario.model';



export interface UsuarioState{
    currentUser: UsuarioRedux | null;
    access_token: string;    
    token_type: string;
    loading:boolean;
    loaded: boolean;
    error:any;    
}

export const initialState:UsuarioState = {
    currentUser: null,    
    access_token: "", 
    token_type : "",   
    loading:false,
    loaded: false, 
    error:null
}

const __usuarioReducer = createReducer(
    initialState,
    on(login, (state) => ({
        ...state, 
        error:null, 
        loading:true,
        loaded:false
    })),
    on(loginSuccess, (state, {user, access_token, token_type})=>({
        ...state,
        loading:false,
        loaded:true,
        currentUser:user,
        access_token:access_token,
        token_type: token_type,        
        error:null
    })),
    on(loginError, (state, {payload})=>({
        ...state,
        loading:false,
        loaded:false,
        currentUser:null,
        access_token:"",
        token_type: "",        
        error:{
            url:payload.url,
            status:payload.status,
            statusText:payload.statusText,                        
        }
    })),
    
    on(logout, (state) => ({
        ...state, 
        error:null, 
        loading:true,
        loaded:false        
    })),

    on(logoutSuccess, (state) => ({
        ...state, 
        currentUser: null,    
        access_token:"", 
        token_type: "",       
        loading:false,
        loaded: true, 
        error:null,            
    })),

    on(logoutError, (state, {payload}) => ({
        ...state,                 
        loading:false,
        loaded: true,                 
        error:{
            url:payload.url,
            status:payload.status,
            statusText:payload.statusText,            
        }
    })),

    on(addAplicacion, (state) => ({
        ...state, 
        error:null, 
        loading:true,
        loaded:false        
    })),

    on(addAplicacionSuccess, (state, {aplicacion, idSprRol}) => ({
        ...state, 
        currentUser: ({
            ...state.currentUser, 
            currentUser: state.currentUser.roles.map((rol)=>({
                ...rol,
                aplicaciones: rol.idSprRol===idSprRol? rol.aplicaciones.push(aplicacion): rol.aplicaciones
            })
            )
        }),            
        loading:false,
        loaded: true, 
        error:null,            
    })),

    on(addAplicacionError, (state, {payload}) => ({
        ...state,                 
        loading:false,
        loaded: true,                 
        error:{
            url:payload.url,
            status:payload.status,
            statusText:payload.statusText,            
        }
    })),
    
);


export function usuarioReducer(state, action){
    return __usuarioReducer(state, action);
}